import { defaultValues } from './hooks'

export const mapInternalStateToPayload = state => {
  const { name, users } = state ?? {}

  return {
    name,
    users: users?.map(user => user.value) || [],
  }
}

export const mapPayloadToInternalState = state => {
  const { name, users } = state ?? {}

  return {
    name: name || defaultValues.name,
    users: users
      ? users.map(user => ({
          value: user.id,
          label: `${user.first_name} ${user.last_name}`,
        }))
      : defaultValues.users,
  }
}
